module.exports = __webpack_public_path__ + "static/img/red-envelope-bottom-ljl.056453e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/alipay/red-envelope-bottom-ljl.png
// module id = BWPK
// module chunks = 1